import { Close } from '@mui/icons-material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import Button from '@mui/material/Button';
import { Formik } from "formik";
import { useEffect, useState } from 'react';
import * as yup from 'yup';
import AddRoom from "../controls/AddRoom";
import NationalityDropdown, { INationality } from '../controls/nationality/NationalityDropdown';
import { resolveNationalityOptions } from '../controls/nationality/nationalityHelper';
import Promotion from '../controls/promotion/promotion';
import RangeDateControl from '../controls/RangeDateControl/RangeDateControl';
import SearchControl from '../controls/SearchControl';
import Toast from '../controls/toast';
import VerticalDivider from '../controls/VerticalDivider';
import { Features, IsFeatureEnabled } from '../featureFlag';
import { getIBE_API } from '../getAPIUrl';
import { getWidgetSessionToken, ibeAuthenticatedFetch } from '../ibeAuth';
import { cityCodeMapping } from '../utility/enum/cityCodeEnums';
import { locationTypeEnum } from '../utility/enum/locationTypeEnum';
import { PromotionEnum } from '../utility/enum/promotionEnum';
import { PromotionEnumKey } from '../utility/enum/promotionEnumKey';
import { StayType } from '../utility/enum/stayTypeEnum';
import { formatDateToIOS, parseDateISOFormat } from '../utility/function/date';
import { getLocaleFromUrl, useTranslation } from '../utility/function/useTranslations';
import { useIbeChatWidget } from '../hooks/useIbeChatWidget';
import { bookNowHandler, formattedDate } from './WidgetHelper';
import './WidgetStyle.css';

interface ILocation {
  location?: any;
  id?: string;
  type: locationTypeEnum;
}

function ReservationWidget(props: any) {
  const brandID = props?.props?.symbol?.brandid
  const chainID = props?.props?.symbol?.chainid
  const ishome = props?.props?.symbol?.ishome || false
  const backgroundColor1 = props?.props?.symbol?.backgroundprimarycolor;
  const backgroundColor2 = props?.props?.symbol?.backgroundprimarycolor;
  const openinNewTab = true;
  var booknowbuttoncolor = props?.props?.symbol?.widgetsearchcolorbutton || props?.props?.symbol?.booknowbuttoncolor;
  booknowbuttoncolor = (booknowbuttoncolor == undefined || booknowbuttoncolor == null || booknowbuttoncolor == 'null') ? '#546477' : `${booknowbuttoncolor}`
  var booknowbuttonhovercolor = props?.props?.symbol?.widgetsearchcolorhoverstate || props?.props?.symbol?.booknowbuttoncolor;
  booknowbuttonhovercolor = (booknowbuttonhovercolor == undefined || booknowbuttonhovercolor == null || booknowbuttonhovercolor == 'null') ? '#546477' : booknowbuttonhovercolor;
  const widgetFontColor = props?.props?.symbol?.widgetfontcolor;
  var widgetSearchFontButtonColor = props?.props?.symbol?.widgetsearchfontcolorbutton;
  widgetSearchFontButtonColor = (widgetSearchFontButtonColor == undefined || widgetSearchFontButtonColor == null || widgetSearchFontButtonColor == 'null') ? '#fff' : `${widgetSearchFontButtonColor}`;
  var widgetSearchFontHoverStateColor = props?.props?.symbol?.widgetsearchfontcolorhoverstate;
  widgetSearchFontHoverStateColor = (widgetSearchFontHoverStateColor == undefined || widgetSearchFontHoverStateColor == null || widgetSearchFontHoverStateColor == 'null') ? '#fff' : `${widgetSearchFontHoverStateColor}`;
  const [destinationList, setDestinationList] = useState<any>();
  const defaultPropCode = props?.props?.symbol?.defaultpropcode;
  const disableSearchControl = props?.props?.symbol?.disablesearchcontrol;
  const [formValues, setFormValues] = useState<any>()
  const [stayType, setStayType] = useState<StayType>(StayType.OVERNIGHT);
  const [isDayBookingEnabled, setIsDayBookingEnabled] = useState<boolean>(false);
  const [isDayBookingLoading, setIsDayBookingLoading] = useState<boolean>(true);
  const [isNationalityEnabled, setIsNationalityEnabled] = useState<boolean>(false);
  const [nationalityData, setNationalityData] = useState<INationality[]>([]);
  const [selectedNationality, setSelectedNationality] = useState<INationality | null>(null);
  const [nationalityError, setNationalityError] = useState<boolean>(false);
  const [locale, setLocale] = useState<string>('en');
  var showSelectedRate = props?.props?.symbol?.showselectedrate ? props?.props?.symbol?.showselectedrate.toLowerCase() === 'true' : true;
  var showGuest = props?.props?.symbol?.showguest? props?.props?.symbol?.showguest.toLowerCase() === 'true' : true;
  var showDestinationSearch = props?.props?.symbol?.showdestinationsearch ? props?.props?.symbol?.showdestinationsearch.toLowerCase() === 'true' : true;

  useEffect(() => {
    if (brandID) {
      if(props?.props?.symbol?.locale){
        setLocale(props?.props?.symbol?.locale);
      }else{
        setLocale(getLocaleFromUrl(brandID) || 'en');
      }
    }
  }, [brandID]);

  // Prefetch short-lived session token (minted server-side via /Session/issueBrowser)
  useEffect(() => {
    if (brandID && chainID) {
      void getWidgetSessionToken(brandID, chainID);
    }
  }, [brandID, chainID]);

  useEffect(() => {
    if ((parent as any)?.window.document.getElementById("86A3B1AA-E95E-45EE-B4E7-34B40AFAC538_Iframe") && locale != null && locale != undefined && locale == "ar") {
      (parent as any).window.document.getElementById("86A3B1AA-E95E-45EE-B4E7-34B40AFAC538_Iframe").contentDocument.documentElement.dir = "rtl";
      (parent as any).window.document.getElementById("86A3B1AA-E95E-45EE-B4E7-34B40AFAC538_Iframe").contentDocument.documentElement.lang = "ar";
    }
  }, [locale]);

  const parseDate = (currentDate: any) => {
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const getNextDate = (dateString: any) => {
    // Handle different input types
    if (!dateString) return new Date();

    let currentDate: Date;

    if (typeof dateString === 'string') {
      // Parse date string directly to avoid timezone issues
      const parts = dateString.split('-');
      if (parts.length === 3) {
        const year = parseInt(parts[0]);
        const month = parseInt(parts[1]) - 1; // months are zero-indexed
        const day = parseInt(parts[2]);
        currentDate = new Date(year, month, day);
      } else {
        // Fallback for other string formats
        currentDate = new Date(dateString);
      }
    } else if (dateString instanceof Date) {
      currentDate = dateString;
    } else {
      // Handle other types
      currentDate = new Date(dateString);
    }

    const nextDate = new Date(currentDate);
    nextDate.setDate(currentDate.getDate() + 1);
    return nextDate;
  }

  let today: any = new Date(Date.now() + 3 * 24 * 60 * 60 * 1000);
  const checkInDate = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + "-" + String(today.getDate()).padStart(2, '0');
  // Get the day and month
  const currentDay = today.getDate();
  const currentMonth = today.getMonth();
  const currentYear = today.getFullYear();
  const { t } = useTranslation();
  // Increment the current date by one day to get the next date
  let nextDate: any = new Date(currentYear, currentMonth, currentDay + 1);
  // // Adjust the month if needed (case: last day of the month)
  // if (nextDate.getMonth() !== currentMonth) {
  //   nextDate  = new Date(currentYear, currentMonth+1, currentDay + 1);
  // }
  const checkOutDate = nextDate.getFullYear() + '-' + String(nextDate.getMonth() + 1).padStart(2, '0') + "-" + String(nextDate.getDate()).padStart(2, '0');
  const [selectedDate, handleDateChange] = useState<any>([checkInDate, checkOutDate]);
  const [bookingURL, setBookingURL] = useState<string>('');
  const [brandInfo, setBrandInfo] = useState<any>();
  const [bookingURLNationality, setBookingURLNationality] = useState<string>('');
  useIbeChatWidget(brandID, chainID, brandInfo);
  const [maxChildAge, setMaxChildAge] = useState(17);
  const [loading, setLoading] = useState(false);
  const [dlysxParam, setDlysxParam] = useState<any>();
  const [isPromotionLoading, setIsPromotionLoading] = useState<boolean>(false);
  const [isBarDataLoading, setIsBarDataLoading] = useState<boolean>(false);
  const [barData, setBarData] = useState<any>([]);
  const [barCurrency, setBarCurrency] = useState<string>("");
  const [demandData, setDemandData] = useState<any>([]);
  const [startDate, setStartDate] = useState<any>([{ date: null, fetch: true }]);
  const [isPageLoaded, setPageLoaded] = useState(false);
  const [eventType, setEventType] = useState("");
  const params = window.location.href.split('?');
  const [promotionData, setPromotionData] = useState<any>([{
    "promoCatId": PromotionEnum.RegularRate,
    "promoCatName": "Regular Rate"
  }]);

  const [toastObj, setToastObj] = useState({
    toastState: false,
    toastMessage: ''
  })

  const [formSchema, setFormSchema] = useState({
    chainID: chainID,
    brandID: brandID,
    destination: {
      location: '',
      type: 0,
      id: ''
    },
    checkInDate: formatDateToIOS(selectedDate[0]),
    checkOutDate: stayType === StayType.DAY_USE ? formatDateToIOS(parseDate(getNextDate(selectedDate[0]))) : formatDateToIOS(selectedDate[1]),
    stayType: stayType,
    guest: [{
      roomCount: 1,
      adultCount: 2,
      childCount: 0
    }],
    promotion: {
      promotionType: PromotionEnumKey.RegularRate,
      promotionCode1: '',
      promotionCode2: '',
    }
  });

  function getLastDateOfNextMonth(dateStr: string) {
    let date = new Date(dateStr);
    let year = date.getFullYear();
    let month = date.getMonth();
    let nextMonth = month + 2;
    if (nextMonth > 11) {
      year += 1;
      nextMonth -= 12;
    }
    let firstDayOfNextMonth: any = new Date(year, nextMonth, 1);
    let lastDayOfNextMonth: any = new Date(firstDayOfNextMonth - 1);
    let formattedDate = lastDayOfNextMonth.toISOString().split('T')[0];
    return formattedDate;
  }

  function increaseDateByTwoMonths(dateString: string) {
    var parts = dateString.split('-');
    var year = parseInt(parts[0]);
    var month = parseInt(parts[1]);
    var day = parseInt(parts[2]);
    month += 2;
    if (month > 12) {
      year += Math.floor((month - 1) / 12);
      month = (month - 1) % 12 + 1;
    }
    var isLeapYear = (year % 4 == 0 && year % 100 != 0) || (year % 400 == 0);
    var daysInMonth = [31, (isLeapYear ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (day > daysInMonth[month - 1]) {
      day = daysInMonth[month - 1];
    }
    var newDateString = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    return newDateString;
  }

  const isNationalityRequiredForBar = () =>
    isNationalityEnabled && nationalityData?.length > 0;

  const canFetchBarData = () => {
    if (formValues?.destination?.type !== 2 || !formValues?.destination?.id) {
      return false;
    }
    if (isNationalityRequiredForBar() && !selectedNationality) {
      return false;
    }
    return true;
  };

  const fetchBarData = async () => {
    if (!canFetchBarData()) {
      return;
    }

    let _startDate = startDate[0];
    if (formValues?.destination?.type == 2 && formValues?.destination?.id && IsFeatureEnabled(Features.DEMAND_CALENDAR) && _startDate?.fetch && !isBarDataLoading) {
      const IBE_lOCATION_API = getIBE_API();
      setIsBarDataLoading(true);
      const today = _startDate?.date ? new Date(`${_startDate?.date}T00:00:00Z`) : new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      ibeAuthenticatedFetch(brandID, chainID, `${IBE_lOCATION_API}/rate/getPropertyBAR`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          propertyId: formValues?.destination?.type == 2 ? formValues?.destination?.id : '',
          checkIn: formattedDate(formValues?.checkInDate),
          checkOut: formattedDate(formValues?.checkOutDate),
          startDate: `${year}-${month}-${day}`,
          endDate: selectedDate.length > 0 && Date.parse(selectedDate[1]) >= today.setMonth(today.getMonth() + 2) ? getLastDateOfNextMonth(selectedDate[1]) : increaseDateByTwoMonths(`${year}-${month}-${day}`),
          channels: [`8ba99da3-0006-4938-8a92-8efb6dbecbd1`],
          nationalityId: selectedNationality?.nationalityId
        })
      })
        .then((response: any) => response.json())
        .then((data) => {
          if (data?.status && data.body?.propertyDateBARs && data.body?.propertyDateBARs.length > 0) {
            let _barData: any;
            if (_startDate.date == null) {
              _barData = [...data.body?.propertyDateBARs];
            } else {
              _barData = [...barData, ...data.body?.propertyDateBARs];
            }
            setBarData(_barData)
            if (data.body?.currency != null) {
              setBarCurrency(data.body?.currency);
            }
          } else {
            //console.log({data});
            //setStartDate({...startDate, fetch: false});
          }
          setIsBarDataLoading(false)
        })
    }
  }

  function getCityCode(cityName: string) {
    const lowerCaseCityName = cityName.toLowerCase();
    for (const city of cityCodeMapping) {
      const lowerCaseCity = city.name.toLowerCase();
      if (lowerCaseCity === lowerCaseCityName) {
        return city.code;
      }
    }
    return null;
  }

  const fetchDemandData = async () => {
    if ((formValues?.destination?.type == 1 || formValues?.destination?.type == 2) && formValues?.destination?.location && demandData.length < 120 && IsFeatureEnabled(Features.DEMAND_CALENDAR)) {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      const city = formValues?.destination?.type == 1 ? formValues?.destination?.location : destinationList.filter((ele: any) => ele?.name == formValues?.destination?.location)[0]?.city;
      const cityCode = getCityCode(city);
      const demandBody = {
        startDate: `${`${year}-${month}-${day}`}`,
        endDate: increaseDateByTwoMonths(increaseDateByTwoMonths(`${`${year}-${month}-${day}`}`)),
        cityCode: cityCode
      }
      if (cityCode != null) {
        try {
          var apiURL = `${process.env.REACT_APP_DOMAIN}/api/13f5ee5a-c5c3-4230-9f57-c9f487896f60_EXT`;

          const response = await fetch(apiURL, {
            method: 'POST',
            body: JSON.stringify({ demandBody: demandBody, reqType: 'POST' })
          });

          if (response.ok) {
            let res = await response.json();
            let result = JSON.parse(res.data);
            let _demandData: any;
            if (result.statusCode == 200) {
              _demandData = [...result?.Data?.city];
              setDemandData(_demandData);
            }
          }
        } catch (error) {
          console.error('Error:', error);
        }
      }
    }
  }

  // Stack only when very narrow; between that and full desktop use compact horizontal
  const HOST_STACK_BREAKPOINT = 1200;
  const WIDGET_STACK_MIN_WIDTH = 700;
  const WIDGET_COMPACT_MAX_WIDTH = 1280;
  const IFRAME_ID = "86A3B1AA-E95E-45EE-B4E7-34B40AFAC538_Iframe";

  const getHostViewportWidth = () => {
    try {
      const parentWidth = (parent as any)?.window?.innerWidth;
      if (typeof parentWidth === 'number' && parentWidth > 0) {
        return parentWidth;
      }
    } catch {
      // cross-origin
    }
    return typeof window !== 'undefined' ? window.innerWidth : HOST_STACK_BREAKPOINT;
  };

  const getWidgetWidth = () =>
    typeof window !== 'undefined' ? window.innerWidth : WIDGET_COMPACT_MAX_WIDTH;

  const shouldUseStackedLayout = () => {
    const hostWidth = getHostViewportWidth();
    const widgetWidth = getWidgetWidth();
    return hostWidth < HOST_STACK_BREAKPOINT || widgetWidth < WIDGET_STACK_MIN_WIDTH;
  };

  const shouldUseCompactHorizontal = () => {
    if (shouldUseStackedLayout()) return false;
    return getWidgetWidth() < WIDGET_COMPACT_MAX_WIDTH;
  };

  const [isStackedLayout, setIsStackedLayout] = useState(() => shouldUseStackedLayout());
  const [isCompactHorizontal, setIsCompactHorizontal] = useState(() => shouldUseCompactHorizontal());

  useEffect(() => {
    const syncLayoutMode = () => {
      const stacked = shouldUseStackedLayout();
      setIsStackedLayout(stacked);
      setIsCompactHorizontal(!stacked && getWidgetWidth() < WIDGET_COMPACT_MAX_WIDTH);
    };
    syncLayoutMode();
    window.addEventListener('resize', syncLayoutMode);
    try {
      (parent as any)?.window?.addEventListener('resize', syncLayoutMode);
    } catch {
      // cross-origin
    }
    return () => {
      window.removeEventListener('resize', syncLayoutMode);
      try {
        (parent as any)?.window?.removeEventListener('resize', syncLayoutMode);
      } catch {
        // ignore
      }
    };
  }, []);

  const getCollapsedIframeHeight = () => {
    if (isStackedLayout) {
      const widgetEl = document.querySelector('.widgetData') as HTMLElement | null;
      const measured = widgetEl?.scrollHeight ?? 0;
      return Math.max(measured + 16, 480);
    }
    return 110;
  };

  const scrollParentIframeIntoView = () => {
    try {
      const iframe = (parent as any)?.window?.document?.getElementById(IFRAME_ID);
      if (!iframe) return;
      // Wait for iframe height expansion so dropdown space is accounted for
      requestAnimationFrame(() => {
        iframe.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        const rect = iframe.getBoundingClientRect();
        const parentWindow = (parent as any).window;
        const overflow = rect.bottom - parentWindow.innerHeight;
        if (overflow > 0) {
          parentWindow.scrollBy({ top: overflow + 24, behavior: 'smooth' });
        }
      });
    } catch {
      // Cross-origin or missing parent helpers — ignore
    }
  };

  useEffect(() => {
    if ((parent as any)?.changeIframeHeight) {
      const handleClickOutside = (event: any) => {
        if (parent.window.document.getElementById(IFRAME_ID) != null) {
          if (event.target.closest("#\\38 6A3B1AA-E95E-45EE-B4E7-34B40AFAC538_Iframe") == null) {
            setEventType("");
          }
        }
      };
      const iframeEl = (parent as any).window.document.getElementById(IFRAME_ID);
      if (iframeEl) {
        iframeEl.style.position = "absolute";
        iframeEl.style.zIndex = "99";
      }
      (parent as any).changeIframeHeight(getCollapsedIframeHeight());

      (parent as any).addEventListener('click', handleClickOutside);

      return () => {
        (parent as any).removeEventListener('click', handleClickOutside);
      };
    }
  }, []);

  useEffect(() => {
    if (!(parent as any)?.changeIframeHeight) return;
    const iframe = (parent as any)?.window?.document?.getElementById(IFRAME_ID);
    if (!iframe) return;

    const isDropdownOpen =
      eventType === "onMouseClick" ||
      eventType === "addRoomClick" ||
      eventType === "promoClick" ||
      eventType === "nationalityClick";

    if (isDropdownOpen) {
      (parent as any).changeIframeHeight(600);
      // Scroll for destination + guests + nationality (calendar already handles visibility)
      if (eventType === "onMouseClick" || eventType === "addRoomClick" || eventType === "nationalityClick") {
        scrollParentIframeIntoView();
      }
    } else if (eventType === "") {
      (parent as any).changeIframeHeight(getCollapsedIframeHeight());
    }
  }, [eventType]);

  // Keep iframe tall enough when stacked layout is active (tablet / narrow desktop)
  useEffect(() => {
    if (!(parent as any)?.changeIframeHeight) return;

    const syncStackedHeight = () => {
      const iframe = (parent as any)?.window?.document?.getElementById(IFRAME_ID);
      if (!iframe) return;
      const isDropdownOpen =
        eventType === "onMouseClick" ||
        eventType === "addRoomClick" ||
        eventType === "promoClick" ||
        eventType === "nationalityClick";
      if (isDropdownOpen) return;
      (parent as any).changeIframeHeight(getCollapsedIframeHeight());
    };

    syncStackedHeight();
    window.addEventListener('resize', syncStackedHeight);
    try {
      (parent as any)?.window?.addEventListener('resize', syncStackedHeight);
    } catch {
      // cross-origin
    }
    return () => {
      window.removeEventListener('resize', syncStackedHeight);
      try {
        (parent as any)?.window?.removeEventListener('resize', syncStackedHeight);
      } catch {
        // ignore
      }
    };
  }, [eventType, isStackedLayout]);

  // Update form schema when stay type changes
  useEffect(() => {
    setFormSchema({
      chainID: chainID,
      brandID: brandID,
      destination: {
        location: '',
        type: 0,
        id: ''
      },
      checkInDate: formatDateToIOS(selectedDate[0]),
      checkOutDate: stayType === StayType.DAY_USE ? formatDateToIOS(parseDate(getNextDate(selectedDate[0]))) : formatDateToIOS(selectedDate[1]),
      stayType: stayType,
      guest: [{
        roomCount: 1,
        adultCount: 2,
        childCount: 0
      }],
      promotion: {
        promotionType: PromotionEnumKey.RegularRate,
        promotionCode1: '',
        promotionCode2: '',
      }
    });
  }, [stayType, selectedDate]);

  useEffect(() => {
    setLoading(true);
    const fetchBrandInfo = async () => {
      // TODO : fetch URL from config
      const IBE_lOCATION_API = getIBE_API();
      ibeAuthenticatedFetch(brandID, chainID, `${IBE_lOCATION_API}/Search/getBrandInfo?brandID=${brandID}`)
        .then((response: any) => response.json())
        .then(async (data) => {
          if (data?.status) {
            const origin = typeof window !== undefined ? window?.origin : '';
            if (origin?.includes('localhost')) {
              setBookingURL('http://localhost:3000')
              if(data?.body?.isNationalityEnabled) {
                setBookingURLNationality(data?.body?.nationality[0]?.natitonalityBookingUrl);
              }
            }
            else {
              setBookingURL(data?.body?.bookingURL)
              if(data?.body?.isNationalityEnabled) {
                setBookingURLNationality(data?.body?.nationality[0]?.natitonalityBookingUrl);
              }
            }
            setBrandInfo(data?.body);
            setIsDayBookingEnabled(!!data?.body?.isDayBookingEnabled);
            const nationalityEnabled = !!data?.body?.isNationalityEnabled;
            setIsNationalityEnabled(nationalityEnabled);
            const nationalities: INationality[] = Array.isArray(data?.body?.nationality) ? data?.body?.nationality : [];
            if (nationalityEnabled && nationalities.length > 0) {
              const options = await resolveNationalityOptions(IBE_lOCATION_API, nationalities, brandID, chainID);
              setNationalityData(options);
            } else {
              setNationalityData(nationalities);
            }
          } else {
            setIsDayBookingEnabled(false);
          }
        })
        .catch((error) => {
          console.error('Error fetching brand info:', error);
          setIsDayBookingEnabled(false);
        })
        .finally(() => {
          setIsDayBookingLoading(false);
        })
    }
    fetchBrandInfo();
  }, []);

  useEffect(() => {
    setLoading(true);
    const fetchPromotionData = async () => {
      // TODO : fetch URL from config
      const IBE_lOCATION_API = getIBE_API();
      setIsPromotionLoading(true);
      ibeAuthenticatedFetch(brandID, chainID, `${IBE_lOCATION_API}/Promotions/getPromotionsCategories`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          brandID: brandID,
          chainID: chainID,
          country: formValues?.destination?.type === 0 ? formValues?.destination?.id : '',
          city: formValues?.destination?.type === 1 ? formValues?.destination?.id : '',
          propertyId: formValues?.destination?.type === 2 ? formValues?.destination?.id : '',
          checkInDate: formattedDate(formValues?.checkInDate),
          checkOutDate: formattedDate(formValues?.checkOutDate)
        })
      })
        .then((response: any) => response.json())
        .then((data) => {
          setIsPromotionLoading(false)
          if (data?.status) {
            setPromotionData(data?.body)
          }
          else {
            setPromotionData([]);
          }
        })
    }
    fetchPromotionData();
  }, [JSON.stringify(formValues?.destination?.id), formValues?.checkInDate, formValues?.checkOutDate]);

  useEffect(() => {
    setDemandData([]);
    setBarData([]);
    setBarCurrency("");
    setStartDate([{ date: null, fetch: true }]);
    if (formValues?.destination?.type == 2 || formValues?.destination?.type == 1) {
      fetchDemandData();
      if (formValues?.destination?.type == 2 && canFetchBarData()) {
        fetchBarData();
      }
    }
  }, [JSON.stringify(formValues?.destination?.id), JSON.stringify(formValues?.destination?.type)]);

  useEffect(() => {
    if (!isNationalityRequiredForBar()) {
      return;
    }

    setBarData([]);
    setBarCurrency("");
    setStartDate([{ date: null, fetch: true }]);

    if (formValues?.destination?.type === 2 && formValues?.destination?.id && selectedNationality) {
      fetchBarData();
    }
  }, [selectedNationality?.nationalityId]);

  useEffect(() => {
    if (!isBarDataLoading) {
      if (startDate.length > 1) {
        let _startDate = [...startDate];
        setStartDate(_startDate);
      } else {
        setStartDate([{ date: startDate[0]?.date, fetch: false }]);
      }
    }
  }, [isBarDataLoading])

  useEffect(() => {
    fetchBarData();
  }, [JSON.stringify(startDate)]);

  const bookNowHandlerWeb = (values: any) => {
    const isNationalityRequired = isNationalityEnabled && nationalityData?.length > 0;
    // Nationality is mandatory (only once a destination is selected, so destination validation stays first)
    if (isNationalityRequired && values?.destination?.id && !selectedNationality) {
      setNationalityError(true);
      // Expand iframe so the error banner under the bar is visible (same idea as dropdowns)
      setEventType('nationalityClick');
      return;
    }
    setNationalityError(false);
    // When a nationality is selected, redirect to its dedicated booking URL
    const effectiveBookingURL = isNationalityRequired && selectedNationality?.nationalityId === '0'
      ? bookingURLNationality
      : bookingURL;
    // Attach the selected nationality code (nc) only when nationality is enabled and selected
    const nationalityCode = isNationalityRequired && selectedNationality ? selectedNationality.nationalityId : undefined;
    bookNowHandler(values, setToastObj, promotionData, destinationList, effectiveBookingURL, brandID, chainID, params, openinNewTab, dlysxParam, locale, nationalityCode);
  }

  const DisplayingErrorMessagesSchema = yup.object().shape({
    destination: yup.object({ location: yup.string().required(t("widget", "destinationIsRequired", locale)) }).required(t("widget", "destinationIsRequired", locale)).typeError(t("widget", "destinationIsRequired", locale)),
    checkInDate: yup.date().nullable().typeError(t("widget", "checkInIsRequired", locale)).required(t("widget", "checkInIsRequired", locale)),
    checkOutDate: stayType === StayType.DAY_USE ? yup.date().nullable() : yup.date().nullable().required(t("widget", "checkOutIsRequired", locale)).typeError(t("widget", "checkOutIsRequired", locale))
  });

  const updateValue = (value: any, type: any, setFieldValue: any, widgetValues: any, touched: any) => {
    touched[type] = true;
    if (isNaN(Date.parse(value)) == false) {
      var v = parseDate(new Date(value))
      setFieldValue(type, v, true);
    }
    else {
      setFieldValue(type, '', true);
    }
    if (type === 'dateRange') {
      var updatedCheckInValue;
      var updatedCheckOutValue;
      if (isNaN(Date.parse(value.startDate._d)) === false) {
        updatedCheckInValue = formatDateToIOS(parseDate(new Date(value.startDate._d)));
        setFieldValue('checkInDate', updatedCheckInValue, true);
      }

      // Handle checkout date based on stay type
      if (stayType === StayType.DAY_USE) {
        // For day use, checkout is next day after checkin
        if (updatedCheckInValue) {
          updatedCheckOutValue = formatDateToIOS(parseDate(getNextDate(updatedCheckInValue)));
          setFieldValue('checkOutDate', updatedCheckOutValue, true);
        }
      } else {
        // For overnight stay, handle normal checkout logic
        if (value?.endDate?._d && isNaN(Date.parse(value.endDate?._d)) === false) {
          if (Date.parse(value.endDate._d) === Date.parse(value.startDate._d)) {
            const nextDate = formatDateToIOS(parseDate(getNextDate(value.startDate._i)));
            setFieldValue('checkOutDate', nextDate, true);
            updatedCheckOutValue = nextDate;
          }
          else {
            updatedCheckOutValue = formatDateToIOS(parseDate(new Date(value.endDate._d)));
            setFieldValue('checkOutDate', updatedCheckOutValue, true);
          }
        }
        else {
          const nextDate = formatDateToIOS(parseDate(getNextDate(value.startDate._d)));
          setFieldValue('checkOutDate', nextDate, true);
          updatedCheckOutValue = nextDate;
        }
      }
      if (updatedCheckInValue && updatedCheckOutValue) {
        handleDateChange([updatedCheckInValue, updatedCheckOutValue]);
      }
    }
  }

  const handleCloseIcon = (setFieldError: any) => {
    setFieldError('destination', '', null);
  }

  const handleStayTypeChange = (newStayType: any, setFieldValue: any, setFieldError: any) => {
    if (newStayType !== null) {
      setStayType(newStayType);
      setFieldValue("stayType", newStayType, true);
      setDestinationList([]); // Clear destination list to force refetch

      // When switching to day use, set checkout date to next day after checkin
      if (newStayType === StayType.DAY_USE) {
        const nextDate = parseDateISOFormat(getNextDate(selectedDate[0]));
        setFieldValue('checkOutDate', nextDate, true);
      } else {
        // When switching to overnight, set checkout to next day if it's same as checkin
        if (selectedDate[0] === selectedDate[1]) {
          const nextDate = parseDateISOFormat(getNextDate(selectedDate[0]));
          setFieldValue('checkOutDate', nextDate, true);
          handleDateChange([selectedDate[0], nextDate]);
        }
      }
    }
  }

  const flagCss = !showDestinationSearch && !showGuest && !showSelectedRate
    ? { maxWidth: "420px", width: "100%", display: "flex", marginLeft: "226px" }
    : !showDestinationSearch && (showGuest || showSelectedRate)
      ? { display: "flex", width: "100%", maxWidth: "869px", marginLeft: "100px" }
      : (showGuest && showSelectedRate)
        ? {}
        : (showGuest || showSelectedRate)
          ? { display: "flex", width: "100%", maxWidth: "869px", marginLeft: "100px" }
          : { maxWidth: "620px", width: "100%", display: "flex", marginLeft: "226px" };

  const handleNationalityChange = (nationality: INationality | null) => {
    setSelectedNationality(nationality);
    if (nationality) {
      setNationalityError(false);
      if (eventType === 'nationalityClick') {
        setEventType('');
      }
    }
  }

  const widgetControl = (initialValues: any, errors: any, handleSubmit: any, touched: any, values: { destination: { location: any; }; }, setFieldValue: any, isValid: any, setFieldError: any, setFieldTouched: any) => {
    setFormValues(values);
    const showNationality = isNationalityEnabled && nationalityData?.length > 0;
    // The fixed CSS grid only applies when all sections are visible; otherwise flagCss switches to flex
    const isDefaultGridLayout = showDestinationSearch && showGuest && showSelectedRate;

    const searchControl = (
      <SearchControl
        setMaxChildAge={setMaxChildAge}
        setDlysxParam={setDlysxParam}
        defaultPropCode={defaultPropCode}
        disableSearchControl={disableSearchControl}
        brandID={brandID}
        chainID={chainID}
        touched={touched}
        errors={errors}
        setFieldValue={setFieldValue}
        fontColor={widgetFontColor !== undefined ? widgetFontColor : "#fff"}
        setDestinationList={setDestinationList}
        values={values}
        booknowbuttoncolor={booknowbuttoncolor}
        booknowbuttonhovercolor={booknowbuttonhovercolor}
        booknowbuttonfontcolor={widgetSearchFontButtonColor}
        buttonHoverFontColor={widgetSearchFontHoverStateColor}
        setPageLoaded={setPageLoaded}
        setEventType={setEventType}
        eventType={eventType}
        isDayBooking={stayType === StayType.DAY_USE}
        setFieldError={setFieldError}
        locale={locale}
        showDestinationSearch={showDestinationSearch}
      />
    );

    return (
      <form
        onSubmit={handleSubmit}
        className={[
          isStackedLayout ? 'widget-layout-stacked' : 'widget-layout-horizontal',
          isCompactHorizontal ? 'widget-layout-compact' : '',
        ].filter(Boolean).join(' ')}
      >
        <Box component="div">
          <Box component="div" className='widgetData'>
            {/* Stay Type Selection - Only show if day booking is enabled */}
            {isDayBookingEnabled && !isDayBookingLoading && (
              <Box component="div" className="stayTypeFloating" sx={{
                backgroundImage: `linear-gradient(${backgroundColor1}, ${backgroundColor2})`,
                borderRadius: '6px 6px 0px 0px',
                padding: '8px 16px',
                boxShadow: '0px 0px 0px #00000029'
              }}>
                <ToggleButtonGroup
                  value={stayType}
                  exclusive
                  onChange={(event, newStayType) => handleStayTypeChange(newStayType, setFieldValue, setFieldError)}
                  sx={{
                    '& .MuiToggleButton-root': {
                      color: widgetFontColor ? widgetFontColor : '#fff',
                      borderRadius: '4px',
                      textTransform: 'none',
                      fontWeight: 500,
                      px: 2,
                      border: 'none',
                      '&.Mui-selected': {
                        backgroundColor: '#fff',
                        color: backgroundColor1 || '#546477',
                        border: `1px solid ${widgetFontColor || '#fff'} !important`,
                        fontWeight: 600,
                        '&:hover': { backgroundColor: '#fff' }
                      },
                      '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.2)' }
                    }
                  }}
                >
                  <ToggleButton value={StayType.OVERNIGHT} className='rounded-0 over-night' style={{ borderRadius: '4px 0px 0px 4px !important' }}>{t("widget", "overnightStay", locale)}</ToggleButton>
                  <ToggleButton value={StayType.DAY_USE} className='rounded-0 day-use' style={{ borderRadius: '0px 4px 4px 0px !important' }}>{t("widget", "dayUse", locale)}</ToggleButton>
                </ToggleButtonGroup>
              </Box>
            )}
            <Box component="div" className="locationCity" style={{
              backgroundImage: `linear-gradient(${backgroundColor1}, ${backgroundColor2})`,
              ...flagCss,
              marginLeft: !showDestinationSearch ? "0px" : flagCss.marginLeft,
              ...(showNationality && isDefaultGridLayout ? {
                width: "100%",
                maxWidth: isCompactHorizontal ? "calc(100% - 172px)" : "calc(100% - 212px)",
                gridTemplateColumns: isCompactHorizontal
                  ? "minmax(80px, 0.9fr) 0px minmax(220px, 1.6fr) 0px minmax(100px, 0.9fr) 0px minmax(80px, 0.75fr) 0px minmax(110px, 0.85fr)"
                  : "minmax(0, 1.1fr) 0px minmax(0, 1.3fr) 0px minmax(0, 1fr) 0px minmax(0, 0.8fr) 0px minmax(0, 1fr)"
              } : {})
            }}>
              {showDestinationSearch ? (
                <>
                  <Box component="div" className={`destination`} onClick={() => { if (eventType != "addRoomClick" && eventType != "promoClick" && eventType != "nationalityClick") setEventType("onMouseClick") }} style={{ paddingRight: locale != "ar" ? "" : "8px" }}>
                    <Box component="span" className="labelText" sx={{ color: widgetFontColor !== undefined ? `${widgetFontColor} !important` : "#fff", textTransform: "uppercase" }}>{t("widget", "destination", locale)}</Box>
                    <Box component="div" sx={{ display: 'flex' }}>
                      <LocationOnIcon sx={{ verticalAlign: 'middle', width: '18px', height: '20px', position: 'relative', left: '-2px', marginTop: '16px', color: widgetFontColor !== undefined ? widgetFontColor : "#fff" }}></LocationOnIcon>
                      {searchControl}
                    </Box>
                    {touched.destination && errors?.destination && <div className='destination-error-msg'><span>{JSON.stringify(errors?.destination?.location || errors?.destination).replace(/"/g, '')}</span><span> <Close onClick={() => handleCloseIcon(setFieldError)} sx={{ fontSize: '15px', top: '3px', pl: '5px', position: 'relative', cursor: 'pointer', width: '25px !important' }} shapeRendering='true' /> </span></div>}
                  </Box>
                  <VerticalDivider />
                </>
              ) : (
                searchControl
              )}

              <Box component="div" className="dateRangeCell" onClick={() => { if (eventType != "addRoomClick" && eventType != "promoClick" && eventType != "nationalityClick") setEventType("onMouseClick") }} style={{ width: "100%" }}>
                {/* <DateRangeControl touched={touched} errors={errors} selectedDate={selectedDate} handleDateChange={(value: any) => updateValue(value, 'dateRange', setFieldValue, values, touched)} /> */}
                <RangeDateControl
                  selectedDate={stayType === StayType.DAY_USE ? [selectedDate[0]] : selectedDate}
                  handleDateChange={(value: any) => updateValue(value, 'dateRange', setFieldValue, values, touched)}
                  fontColor={widgetFontColor !== undefined ? widgetFontColor : "#fff"}
                  booknowbuttoncolor={booknowbuttoncolor}
                  booknowbuttonhovercolor={booknowbuttonhovercolor}
                  booknowbuttonfontcolor={widgetSearchFontButtonColor}
                  buttonHoverFontColor={widgetSearchFontHoverStateColor}
                  setEventType={setEventType}
                  eventType={eventType}
                  barData={barData}
                  navStartDate={startDate}
                  setStartDate={setStartDate}
                  demandData={demandData}
                  barCurrency={barCurrency}
                  isDemandCalendar={IsFeatureEnabled(Features.DEMAND_CALENDAR) ? true : false}
                  destinationType={values?.destination}
                  propertyID={formValues?.destination?.type == 2 ? formValues?.destination?.id : ''}
                  hideCheckout={stayType === StayType.DAY_USE}
                  locale={locale}
                />
              </Box>
              {(showGuest || showSelectedRate || showNationality) && <VerticalDivider />}
              {showGuest && (
                <>
                  <Box component="div" className={`guestData`} onClick={() => setEventType("addRoomClick")} style={{ paddingLeft: locale != "ar" ? "20px" : "0px", paddingRight: locale != "ar" ? "0px" : "20px" }}>
                    <Box component="span" className="labelText" sx={{ color: widgetFontColor !== undefined ? `${widgetFontColor} !important` : "#fff" }}>{t("widget", "guests", locale)}</Box>
                    <Box component="div" className="guestValue" sx={{ position: 'relative', top: '51px', cursor: 'pointer', maxWidth: '100%' }}>
                      <AddRoom
                        widgetValues={values}
                        setFieldValue={setFieldValue}
                        booknowbuttoncolor={booknowbuttoncolor}
                        maxChildAge={maxChildAge}
                        fontColor={widgetFontColor !== undefined ? widgetFontColor : "#fff"}
                        booknowbuttonhovercolor={booknowbuttonhovercolor}
                        setEventType={setEventType}
                        eventType={eventType}
                        ishome={ishome}
                        brandId={brandID}
                        locale={locale}
                      />
                    </Box>
                  </Box>
                  <VerticalDivider />
                </>
              )}
              {showNationality && (
                <>
                  <Box component="div" className="nationalityData" onClick={() => setEventType("nationalityClick")} style={{ paddingLeft: locale != "ar" ? "20px" : "0px", paddingRight: locale != "ar" ? "0px" : "20px" }}>
                    <NationalityDropdown
                      nationalityData={nationalityData}
                      selectedNationality={selectedNationality}
                      onChange={handleNationalityChange}
                      fontColor={widgetFontColor !== undefined ? widgetFontColor : "#fff"}
                      booknowbuttoncolor={booknowbuttoncolor}
                      locale={locale}
                      hasError={nationalityError}
                      onClearError={() => setNationalityError(false)}
                      setEventType={setEventType}
                    />
                  </Box>
                  {showSelectedRate && <VerticalDivider />}
                </>
              )}
              {showSelectedRate && (
                <Box component="div" className="promoData" style={!(isValid && !!values.destination?.location) || isPromotionLoading ? { opacity: '.5', paddingLeft: locale != "ar" ? "20px" : "0px", paddingRight: locale != "ar" ? "0px" : "20px" } : { paddingLeft: locale != "ar" ? "20px" : "0px", paddingRight: locale != "ar" ? "0px" : "20px" }} onClick={() => setEventType("promoClick")}>
                  {/* <Box component="span" className="labelText" sx={{ color: widgetFontColor !== undefined ? `${widgetFontColor} !important` : "#fff" }} >{t("widget", "selectedRate", locale)}</Box> */}
                  <Box component="div"  >
                    <Promotion
                      setFieldValue={setFieldValue}
                      booknowbuttoncolor={booknowbuttoncolor}
                      booknowbuttonhovercolor={booknowbuttonhovercolor}
                      widgetValues={values}
                      buttonFontColor={widgetSearchFontButtonColor}
                      buttonHoverFontColor={widgetSearchFontHoverStateColor}
                      isDisable={isValid && !!values.destination?.location}
                      values={values}
                      fontColor={widgetFontColor !== undefined ? widgetFontColor : "#fff"}
                      promotionData={promotionData}
                      isPromotionLoading={isPromotionLoading}
                      isPageLoaded={isPageLoaded}
                      brandID={brandID}
                      setEventType={setEventType}
                      eventType={eventType}
                      ishome={ishome}
                      locale={locale}
                    />
                  </Box>
                </Box>
              )}
            </Box>
            <Box component="div" className={`bookNowMain`} style={{paddingLeft: locale != "ar" ? (isCompactHorizontal ? "12px" : "20px") : "0px", paddingRight: locale != "ar" ? "0px" : (isCompactHorizontal ? "12px" : "20px")}}>
              <Button
                id='show-toast-button'
                disabled={bookingURL === '' || bookingURL == null}
                variant="contained" sx={{
                  backgroundColor: (booknowbuttoncolor == undefined || booknowbuttoncolor == null || booknowbuttoncolor == 'null') ? '#546477 !important' : `${booknowbuttoncolor} !important`,
                  color: (widgetSearchFontButtonColor == undefined || widgetSearchFontButtonColor == null || widgetSearchFontButtonColor == 'null') ? '#fff !important' : `${widgetSearchFontButtonColor} !important`,
                  width: isCompactHorizontal ? '160px' : '192px',
                  minWidth: isCompactHorizontal ? '160px' : '192px',
                  height: '70px',
                  borderRadius: '6px',
                  fontSize: isCompactHorizontal ? '13px' : '14px',
                  fontFamily: 'Montserrat, sans-serif',
                  px: isCompactHorizontal ? '10px' : undefined,
                  boxShadow: '0px 3px 6px #00000029 !important',
                  '&:hover': {
                    'opacity': '70% !important',
                    backgroundColor: (booknowbuttonhovercolor == undefined || booknowbuttonhovercolor == null || booknowbuttonhovercolor == 'null') ? '#546477 !important' : `${booknowbuttonhovercolor} !important`,
                    color: (widgetSearchFontHoverStateColor == undefined || widgetSearchFontHoverStateColor == null || widgetSearchFontHoverStateColor == 'null') ? '#fff !important' : `${widgetSearchFontHoverStateColor} !important`,
                  },
                  textTransform: "uppercase"
                }} type="button" onClick={handleSubmit} className="bookNowResponsive">{t("widget", 'bookNow', locale)}</Button>
            </Box>
          </Box>
        </Box>
      </form>
    )
  }

  return (
    <>
      <Toast toastState={toastObj.toastState} setToastState={setToastObj} toastMessage={toastObj.toastMessage} locale={locale}/>
      <Formik initialValues={formSchema} validationSchema={DisplayingErrorMessagesSchema} onSubmit={bookNowHandlerWeb} className="responsiveWidget">
        {({ initialValues, errors, handleSubmit, touched, values, setFieldValue, isValid, setFieldError, setFieldTouched }: any): any => (
          <>{widgetControl(initialValues, errors, handleSubmit, touched, values, setFieldValue, isValid, setFieldError, setFieldTouched)}</>
        )}
      </Formik>
    </>
  )
}


export default ReservationWidget;